import script from "./DealsFiltersBar.vue?vue&type=script&setup=true&lang=js"
export * from "./DealsFiltersBar.vue?vue&type=script&setup=true&lang=js"

import "./DealsFiltersBar.vue?vue&type=style&index=0&id=2f35b330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f35b330"]])

export default __exports__